<div class="inner-container">
  <div class="btn-container">
    <button (click)="handleAddNewSkuDialog()" mat-button class="mb-15 ml-10">
      Create SKU
    </button>

    <button (click)="handleDeleteSkuDialog()" [disabled]="!selectedSku" mat-button class="mb-15 ml-10">
      Delete SKU
    </button>

    <button (click)="handleEditSkuDialog()" [disabled]="!selectedSku" mat-button class="mb-15 ml-10">
      Edit SKU
    </button>

    <span class="spacer"></span>
    <button (click)="navigateToDetails(selectedSku!)" mat-flat-button color="primary" class="primary-btn mb-15">
      View SKU
    </button>
  </div>
  @if (isloading) {
    <mat-progress-bar mode="indeterminate" value="80" class="mb-15"> </mat-progress-bar>
  } @else {
    <div>
      <table mat-table [dataSource]="dataSource" matSort>
        <!-- Sku Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>SKU Name</th>
          <td mat-cell *matCellDef="let element">{{ element.sku_name }}</td>
        </ng-container>

        <!-- Category Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
          <td mat-cell *matCellDef="let element">{{ element.description }}</td>
        </ng-container>

        <!-- Details Column -->
        <ng-container matColumnDef="enabled">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Enabled</th>
          <td mat-cell *matCellDef="let element">{{ element.enabled }}</td>
        </ng-container>

        <tr class="header-shadow" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="setSelected(row)"
        (dblclick)="navigateToDetails(selectedSku!)" [ngClass]="{ 'selectedRow': selectedSku === row.sku_name }"></tr>
      </table>
    </div>
  }
</div>
